import React from "react";
import { Content, Wrapper } from "./CardWithInfoMol.styled";
function CardWithInfoMol(_ref) {
  var backgroundImage = _ref.backgroundImage,
    content = _ref.content,
    cardHeightSpace = _ref.cardHeightSpace;
  return /*#__PURE__*/React.createElement(Wrapper, {
    justifyContent: "flex-start",
    alignItems: "flex-end",
    $cardHeightSpace: cardHeightSpace,
    $backgroundImage: backgroundImage
  }, /*#__PURE__*/React.createElement(Content, null, content));
}
export default CardWithInfoMol;